/**
 * Navigation Menu Handler
 * Handles mobile menu toggle functionality
 */
class NavigationHandler {
    constructor() {
        this.toggle = null;
        this.links = null;
        this.init();
    }

    init() {
        // Wait for DOM to be ready
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.setupEventListeners());
        } else {
            this.setupEventListeners();
        }
    }

    setupEventListeners() {
        this.toggle = document.getElementById('menu-toggle');
        this.links = document.getElementById('menu-links');

        if (!this.toggle || !this.links) {
            return; // Elements not found, exit gracefully
        }

        // Menu toggle click event
        this.toggle.addEventListener('click', (e) => {
            e.preventDefault();
            this.toggleMenu();
        });

        // Click outside to close menu
        document.addEventListener('click', (e) => {
            if (!this.toggle.contains(e.target) && !this.links.contains(e.target)) {
                this.closeMenu();
            }
        });

        // Close menu on escape key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                this.closeMenu();
            }
        });
    }

    toggleMenu() {
        const isOpen = this.links.style.display === 'block';
        
        if (isOpen) {
            this.closeMenu();
        } else {
            this.openMenu();
        }
    }

    openMenu() {
        this.links.style.display = 'block';
        this.updateButtonText('CLOSE');
        this.toggle.setAttribute('aria-expanded', 'true');
    }

    closeMenu() {
        this.links.style.display = 'none';
        this.updateButtonText('MENU');
        this.toggle.setAttribute('aria-expanded', 'false');
    }

    updateButtonText(text) {
        // Find the hamburger icon to preserve it
        const hamburgerIcon = this.toggle.querySelector('.hamburger-icon');
        
        if (hamburgerIcon) {
            // Clear the button content but preserve the hamburger icon
            this.toggle.innerHTML = '';
            this.toggle.appendChild(hamburgerIcon);
            this.toggle.appendChild(document.createTextNode(text));
        } else {
            // Fallback if no hamburger icon found
            this.toggle.textContent = text;
        }
    }
}

// Initialize navigation when script loads
export default NavigationHandler;

// Auto-initialize if not using modules
if (typeof module === 'undefined') {
    new NavigationHandler();
}